import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { EntityRepresentation } from "@/core/services/api/interfaces/admin/TimelineModel";

@Module
export default class TimelineModule extends VuexModule {
  entity_classes: EntityRepresentation[] = [];
  entity_classes_keyed: { [index: string]: EntityRepresentation } = {};
  get getTimelineEntityClasses(): EntityRepresentation[] {
    return this.entity_classes;
  }

  get timelineEntityClassBySlug() {
    return (slug: string) => {
      return this.entity_classes_keyed[slug] || null;
    };
  }

  @Action({ rawError: true })
  [Actions.ADMIN_TIMELINE_ENTITY_CLASSES_LOAD]() {
    return ApiService.admin.timeline
      .listEntityClasses()
      .then(ApiService.unwrapPaginationResponse<EntityRepresentation>)
      .then((response) => {
        this.context.commit(
          Mutations.ADMIN_TIMELINE_ENTITY_CLASSES_SET,
          response.data
        );
      })
      .catch(console.error);
  }

  @Mutation
  [Mutations.ADMIN_TIMELINE_ENTITY_CLASSES_SET](
    classes: EntityRepresentation[]
  ) {
    console.log(classes);
    this.entity_classes = classes;
    this.entity_classes_keyed = classes.reduce((acc, item) => {
      acc[item.slug] = item;

      return acc;
    }, {});
  }
}
